import React, { FC } from 'react';
import Flex from './Flex';
import Loading from './Loading';

const LoadingScreen: FC = () => {
  return (
    <Flex align="center" justify="center" height={400}>
      <Loading size="6x" />
    </Flex>
  );
};

export default LoadingScreen;
